// App-wide toast host. Subscribes to notify() events (raised by the axios
// error interceptor) and shows them as a MUI Snackbar/Alert so failed API
// calls are never silent. Mounted once in App.
import { useEffect, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { subscribeNotify } from "../notify";

export default function Notifier() {
  const [toast, setToast] = useState(null); // { message, severity } | null

  useEffect(() => subscribeNotify(setToast), []);

  const handleClose = (_event, reason) => {
    if (reason === "clickaway") return;
    setToast(null);
  };

  return (
    <Snackbar
      open={Boolean(toast)}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity={toast?.severity || "error"}
        variant="filled"
        onClose={handleClose}
        sx={{ width: "100%" }}
      >
        {toast?.message}
      </Alert>
    </Snackbar>
  );
}
